export const EMAIL_REGEX = /^[A-Z0-9._%+'-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const RESTRICT_SPEC_REGEX = /^[^-!@#$%^&*()_{}":><+,/;=|\s]*$/;
export const RESTRICT_SPEC_REGEX_FOR_NAME = /^[^-!@#$%^&*()~.?[\]'_{}":><+,\\/;=|\s]*$/;
//export const RESTRICT_SPEC_REGEX_FOR_GATEWAY_NAME =  /^[^-!@#$%^&*()~.?[\]'_{}":><+,\\/;=|A-Z\s]*$/;
export const RESTRICT_DEVICE_WITHOUT_SPACE_REGEX = /^[a-z0-9-_:]*$/;
export const RESTRICT_BLG_DEVICE_SPACE_REGEX = /^[a-zA-Z0-9-_\s]*$/;
export const DEVICE_PROFILE_REGEX = /^[a-zA-Z0-9-_]*$/;
export const RESTRICT_SPEC_WITHOUT_SPACE_REGEX = /^[^-!@#$%^&*()_{}":><+/;=|]*$/;
export const ONLY_NUMBER = /^[0-9\b]+$/;
export const ONLY_NUMBER_5TO20 = /^\d{5,20}$/;
export const DECIMAL_NUMBER = /^[-+0-9.]+$/;
export const SPECIAL_CHAR = /[!~@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/g;
export const LATITUDE_REGEX = /^-?([1-8]?[0-9]\.{1}\d{6}$|90\.{1}0{6}$)/;
export const LONGITUDE_REGEX = /^-?((([1]?[0-7][0-9]|[1-9]?[0-9])\.{1}\d{6}$)|[1]?[1-8][0]\.{1}0{6}$)/;
export const IP_ADDRESS = /^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/;
export const ALPHA_NUMBERIC = /^[a-zA-Z0-9]+$/;
export const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const LOCAL_EXPIRATION = 'expires_on';
export const USER_SETTINGS = 'user_settings';
export const LOCAL_USER_DATA = 'user_data';
export const REMEMBER_ME_DATA = 'remember_me_data';
export const SELECTED_ORGANIZATION = 'selected_organization';
export const EULA_FILE_PATH = '../../../EULA.pdf';
export const US_CA_COUNTRY_CODE = '+1';
export const VENDOR_NAME = 'sierra';
export const EMPTY_STRING = '';
export const FX30_ETHERNET = 'fx30';
export const FX30S_SERIAL = 'fx30s';
export const MESH = 'mesh';

export const MESH_TYPE = 'BLE Mesh';

export const BLG300 = 'blg300';
export const BLG400 = 'blg400';

export const BLUEPRINT_ORGANIZATION_NAME = 'BLI Pre Production Test';

export const BRAND_NAME = 'Brightlayer Industrial';
export const CONTACT_EMAIL = 'BLsupport@eaton.com';
export const PLAN_LINK =
    'https://www.eaton.com/us/en-us/digital/brightlayer/brightlayer-industrial-suite/intelligent-lighting/intelligent-lighting-subscription-plans-comparison.html';
export const CONTACT_PHONENO = '877-386-2273';
export const EXPLORE_LINK_TEXT = 'Intelligent Lighting subscription plans comparison (eaton.com)';
export const IDLE_TIMER_INACTIVE = 1000 * 15 * 60;
export const IDLE_TIMER_LOGOUT = 5 * 60;
export const TCP_TYPE = 'tcp';
export const SERIAL_TYPE = 'serial';
/////////////////////////////////////////////////////////////////////////////////////
// NOTE: The following Regular expressions are used for the
//       password validation logic. It is critical that they not
//       be "global" regexes  (no 'g' after the last slash). Global
//       regexes maintain state when their .test() function is called.
//       We don't want that.
export const LENGTH_REGEX = /^.{8,16}$/;
export const NUMBERS_REGEX = /[0-9]+/;
export const UPPER_CASE_REGEX = /[A-Z]+/;
export const LOWER_CASE_REGEX = /[a-z]+/;
/////////////////////////////////////////////////////////////////////////////////////
export const phaseConnection = [
    { id: 0, value: 'Phase A' },
    { id: 1, value: 'Phase B' },
    { id: 2, value: 'Phase C' },
    { id: 3, value: 'Phase AB' },
    { id: 4, value: 'Phase AC' },
    { id: 5, value: 'Phase BC' },
];

///////////////////////////////////////////////////////////////////////
export const scaleRange = [
    { id: 0, value: 'Auto' },
    { id: 10, value: '10' },
    { id: 20, value: '20' },
    { id: 50, value: '50' },
    { id: 100, value: '100' },
    { id: 200, value: '200' },
    { id: 500, value: '500' },
    { id: 1000, value: '1000' },
    { id: 2500, value: '2500' },
    { id: 5000, value: '5000' },
    { id: 10000, value: '10000' },
    { id: 25000, value: '25000' },
];

export const xAxisScaleValue = [
    { value: 0, tickInterval: 20, max: 60, min: 0 },
    { value: 10, tickInterval: 5, max: 10, min: 0 },
    { value: 20, tickInterval: 10, max: 20, min: 0 },
    { value: 50, tickInterval: 20, max: 50, min: 0 },
    { value: 100, tickInterval: 50, max: 100, min: 0 },
    { value: 200, tickInterval: 100, max: 200, min: 0 },
    { value: 500, tickInterval: 200, max: 500, min: 0 },
    { value: 1000, tickInterval: 500, max: 1000, min: 0 },
    { value: 2500, tickInterval: 1000, max: 2500, min: 0 },
    { value: 5000, tickInterval: 2000, max: 5000, min: 0 },
    { value: 10000, tickInterval: 5000, max: 10000, min: 0 },
    { value: 25000, tickInterval: 20000, max: 25000, min: 0 },
];
///////////////////////////////////////////////////////////////////////
